import { createAttachmentsApi } from '#/api/platform/attachments';

/** 收款憑證（財務 owner；`fms.customer_collection.read`／`.update`）。 */
export const collectionReceiptAttachmentsApi = createAttachmentsApi(
  (receiptId) => `/fms/customer-collection-receipts/${receiptId}/attachments`,
);

/** 歷史核對憑證；VERIFIED 後不可再改。 */
export const legacyReconciliationAttachmentsApi = createAttachmentsApi(
  (reconciliationId) => `/fms/customer-collection-legacy-reconciliations/${reconciliationId}/attachments`,
);
